import React from 'react';
import './Tooltip.css';

export type TooltipPosition = 
  | 'top-left'
  | 'top-center' 
  | 'top-right'
  | 'bottom-left'
  | 'bottom-center'
  | 'bottom-right'
  | 'left'
  | 'right';

interface TooltipProps {
  text: string;
  visible: boolean;
  position?: TooltipPosition;
  className?: string;
}

const Tooltip: React.FC<TooltipProps> = ({ 
  text, 
  visible, 
  position = 'top-right',
  className = '' 
}) => {
  if (!visible) return null;

  return (
    <div className={`tooltip tooltip--${position} ${className}`}>
      <div className="tooltip__content">
        <p className="tooltip__text text-body-small">
          {text}
        </p>
      </div>
    </div>
  );
};

export default Tooltip;
